var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnWallet = function SvgIcnWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 15.119c.746 0 1.35-.608 1.35-1.357 0-.75-.604-1.357-1.35-1.357-.746 0-1.35.607-1.35 1.357s.604 1.357 1.35 1.357Z",
    fill: "#292525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.376 3.316c.079.324.096.685.096 1.034v1.33h-1.8V4.35a.452.452 0 0 0-.563-.457 7.145 7.145 0 0 0-.224.056L6.693 6.216c-.38.145-.675.278-.905.4.261-.06.533-.092.812-.092h10.8c1.988 0 3.6 1.62 3.6 3.619v7.238C21 19.38 19.388 21 17.4 21H6.6C4.612 21 3 19.38 3 17.381V8.313c0-.829.095-1.51.63-2.233.518-.696 1.354-1.15 2.466-1.572a.895.895 0 0 1 .078-.025L14.421 2.2c.435-.116.841-.194 1.205-.2.366-.007.78.059 1.138.327.363.273.531.653.612.988ZM4.806 9.988l-.006 1.02v6.373c0 1 .806 1.81 1.8 1.81h10.8c.994 0 1.8-.81 1.8-1.81v-7.238c0-1-.806-1.81-1.8-1.81H6.6c-.942 0-1.715.728-1.793 1.655Z",
    fill: "#292525"
  })));
};
export default SvgIcnWallet;